"use client"

import { useState, useEffect } from "react"
import MnemonicCard from "../components/MnemonicCard"
import SearchBar from "../components/SearchBar"
import { Bookmark } from "lucide-react"

const BookmarksPage = () => {
  const [bookmarks, setBookmarks] = useState([])
  const [filteredBookmarks, setFilteredBookmarks] = useState([])

  // Load bookmarks from localStorage
  useEffect(() => {
    const savedBookmarks = JSON.parse(localStorage.getItem("bookmarks") || "[]")
    setBookmarks(savedBookmarks)
    setFilteredBookmarks(savedBookmarks)
  }, [])

  // Handle search
  const handleSearch = (term) => {
    if (term === "") {
      setFilteredBookmarks(bookmarks)
    } else {
      const filtered = bookmarks.filter(
        (bookmark) =>
          bookmark.concept.toLowerCase().includes(term.toLowerCase()) ||
          bookmark.chapter.toLowerCase().includes(term.toLowerCase()) ||
          bookmark.mnemonic.toLowerCase().includes(term.toLowerCase()) ||
          bookmark.subject.toLowerCase().includes(term.toLowerCase()),
      )
      setFilteredBookmarks(filtered)
    }
  }

  // Listen for changes in localStorage (when a bookmark is added/removed)
  useEffect(() => {
    const handleStorageChange = () => {
      const savedBookmarks = JSON.parse(localStorage.getItem("bookmarks") || "[]")
      setBookmarks(savedBookmarks)
      setFilteredBookmarks(savedBookmarks)
    }

    window.addEventListener("storage", handleStorageChange)

    // Custom event for when bookmarks change within the same window
    window.addEventListener("bookmarksChanged", handleStorageChange)

    return () => {
      window.removeEventListener("storage", handleStorageChange)
      window.removeEventListener("bookmarksChanged", handleStorageChange)
    }
  }, [])

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Bookmarks Banner */}
      <div className="bg-yellow-50 rounded-lg p-6 mb-8 shadow-sm">
        <div className="flex items-center space-x-4">
          <div className="p-3 bg-white rounded-full shadow-sm">
            <Bookmark className="w-8 h-8 text-yellow-500" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-yellow-600">Your Bookmarked Mnemonics</h1>
            <p className="text-gray-600">Access your saved mnemonics for quick revision</p>
          </div>
        </div>
      </div>

      {/* Search Bar */}
      <div className="mb-8">
        <SearchBar onSearch={handleSearch} placeholder="Search your bookmarks..." />
      </div>

      {/* Bookmarks Grid */}
      {filteredBookmarks.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredBookmarks.map((bookmark) => (
            <MnemonicCard key={bookmark.id} mnemonic={bookmark} />
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <p className="text-gray-500 text-lg mb-4">You haven't bookmarked any mnemonics yet.</p>
          <a
            href="/"
            className="inline-block px-6 py-3 bg-yellow-500 text-white rounded-md hover:bg-yellow-600 transition-colors"
          >
            Explore Mnemonics
          </a>
        </div>
      )}
    </div>
  )
}

export default BookmarksPage
